import { createSlice } from "@reduxjs/toolkit";
import {
  getAllAdhocJobsAsync,
  getAdhocJobByJobIdAsync,
  getAdhocJobCostAsync,
  updateAdhocJobAdminStatusAsync,
  updateAdhocJobTextValidationAsync,
} from "./adhocjob.async";

const initialState = {
  adhocJobsListLoader: false,
  adhocJobsList: {},
  activityViewByJobIdLoading: false,
  activityViewByJobIdInfo: {},
  activityViewByJobId: {},
  costReportLoader: false,
  costReport: null,
  adminStatusUpdateLoader: false,
  textValidationUpdateLoader: false,
};

const adhocJobSlice = createSlice({
  name: "adhocjob",
  initialState,
  reducers: {
    emptyAdhocJobs: (state) => {
      state.adhocJobsList = {};
    },
    emptyCostReport: (state) => {
      state.costReport = null;
    },
  },
  extraReducers: (builder) => {
    // Get All Adhoc Jobs
    builder.addCase(getAllAdhocJobsAsync.pending, (state) => {
      state.adhocJobsListLoader = true;
    });
    builder.addCase(getAllAdhocJobsAsync.fulfilled, (state, action) => {
      state.adhocJobsListLoader = false;
      state.adhocJobsList = action.payload;
    });
    builder.addCase(getAllAdhocJobsAsync.rejected, (state) => {
      state.adhocJobsListLoader = false;
    });

    // Update Admin Status
    builder.addCase(updateAdhocJobAdminStatusAsync.pending, (state) => {
      state.adminStatusUpdateLoader = true;
    });
    builder.addCase(
      updateAdhocJobAdminStatusAsync.fulfilled,
      (state, action) => {
        state.adminStatusUpdateLoader = false;
        const updatedJob = action.payload?.data;
        if (updatedJob && state.adhocJobsList?.data?.jobs) {
          const idx = state.adhocJobsList.data.jobs.findIndex(
            (j) => j._id === updatedJob._id
          );
          if (idx !== -1) {
            state.adhocJobsList.data.jobs[idx] = {
              ...state.adhocJobsList.data.jobs[idx],
              adminStatus: updatedJob.adminStatus,
            };
          }
        }
      }
    );
    builder.addCase(updateAdhocJobAdminStatusAsync.rejected, (state) => {
      state.adminStatusUpdateLoader = false;
    });

    // Get Activity View By JobId
    builder.addCase(getAdhocJobByJobIdAsync.pending, (state) => {
      state.activityViewByJobIdLoading = true;
      state.activityViewByJobIdInfo = {};
      state.activityViewByJobId = {};
    });
    builder.addCase(getAdhocJobByJobIdAsync.fulfilled, (state, action) => {
      state.activityViewByJobIdLoading = false;
      state.activityViewByJobIdInfo = {};
      state.activityViewByJobId = action.payload?.data;
    });
    builder.addCase(getAdhocJobByJobIdAsync.rejected, (state) => {
      state.activityViewByJobIdLoading = false;
      state.activityViewByJobIdInfo = {};
      state.activityViewByJobId = {};
    });

    // Get Cost Report
    builder.addCase(getAdhocJobCostAsync.pending, (state) => {
      state.costReportLoader = true;
      state.costReport = null;
    });
    builder.addCase(getAdhocJobCostAsync.fulfilled, (state, action) => {
      state.costReportLoader = false;
      state.costReport = action.payload?.data;
    });
    builder.addCase(getAdhocJobCostAsync.rejected, (state) => {
      state.costReportLoader = false;
      state.costReport = null;
    });

    // Update Text Validation
    builder.addCase(updateAdhocJobTextValidationAsync.pending, (state) => {
      state.textValidationUpdateLoader = true;
    });
    builder.addCase(
      updateAdhocJobTextValidationAsync.fulfilled,
      (state, action) => {
        state.textValidationUpdateLoader = false;
      }
    );
    builder.addCase(updateAdhocJobTextValidationAsync.rejected, (state) => {
      state.textValidationUpdateLoader = false;
    });
  },
});

export const { emptyAdhocJobs, emptyCostReport } = adhocJobSlice.actions;
export default adhocJobSlice.reducer;